export function initialize(selector) {
    let elements = document.querySelectorAll(selector);
    let maxHeight = 0;

    elements.forEach(function (element) {
        let height = outerHeight(element);

        if (height > maxHeight) {
            maxHeight = height;
        }
    });

    elements.forEach(function (element) {
        element.style.height = maxHeight+'px';
    });
}

function outerHeight(el) {
  let height = el.offsetHeight;
  let style = getComputedStyle(el);

  return height + parseInt(style.marginTop) + parseInt(style.marginBottom);
}

export default {

};
